'use client'
import { useTranslations } from 'next-intl'
import React from 'react'

import { HeaderControl } from '@maestro/commerce-blocks/components/header-controls'
import { useHeaderControls } from '@maestro/commerce-blocks/components/header-controls/batons/use-header-controls'
import { useCartContext } from '@maestro/commerce-blocks/context/cart.context'
import { useIsHydrated } from '@maestro/commerce-blocks/hooks/use-is-hydrated'
import { useWishlistContext } from '@maestro/commerce-blocks/providers/wishlist/wishlist.context'
import { theme } from '@maestro/local/theme'

const HeaderControls = () => {
  const { cart } = useCartContext()
  const { wishlistCount: rawWishlistCount } = useWishlistContext()
  const isHydrated = useIsHydrated()
  const wishlistCount = isHydrated ? rawWishlistCount : 0

  const {
    handleClickCart,
    handleClickCartUrl,
    handleClickMyAccount,
    handleClickWishlist,
    isUserLoggedIn,
  } = useHeaderControls()
  const t = useTranslations('commerce-blocks')
  const {
    urls,
    cart: { isSlidein },
  } = theme()

  return (
    <ul className="header__controls">
      <li className="header__controls-item">
        <HeaderControl
          icon="heart-empty"
          ariaLabel={t('wishlist.contains-items', { count: wishlistCount })}
          title={t('header-controls.wishlist')}
          onClick={handleClickWishlist}
          count={wishlistCount}
        />
      </li>
      <li className="header__controls-item">
        <HeaderControl
          icon="user"
          ariaLabel={t('header-controls.my-account')}
          title={t('header-controls.my-account')}
          {...(isUserLoggedIn
            ? { url: urls.myAccount, onClick: handleClickMyAccount }
            : { url: urls.login })} // Login won’t be triggered from here, so there’s no additional onClick action
        />
      </li>
      <li className="header__controls-item">
        <HeaderControl
          icon="cart"
          ariaLabel={t('cart.contains-items', {
            count: cart.entries.length,
          })}
          {...(isSlidein
            ? { onClick: handleClickCart }
            : { url: urls.cart, onClick: handleClickCartUrl })}
          count={cart.totalQuantity}
        />
      </li>
    </ul>
  )
}

export default HeaderControls
